import * as tslib_1 from "tslib";
import { HttpBackend, HttpClient } from '@angular/common/http';
import { map, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common/http";
var User = /** @class */ (function () {
    function User() {
    }
    return User;
}());
export { User };
var host = environment.host;
var _a = environment.auth, client_id = _a.client_id, redirectUri = _a.redirectUri, authorization = _a.authorization;
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(router, handler) {
        this.router = router;
        this.http = new HttpClient(handler);
    }
    AuthenticationService.prototype.getGrantCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            headers: {
                                client_id: client_id
                            }
                        };
                        body = {
                            client_id: client_id,
                            redirect_uri: redirectUri
                        };
                        return [4 /*yield*/, this.http.post(host + "/oauth/grant-code", body, options)
                                .pipe(retry(3), map(function (response) {
                                return response.redirect_uri.split('?code=')[1];
                            }))
                                .toPromise()
                                .then(function (response) {
                                return _this.grantCode = response;
                            }).catch(function (err) {
                                return _this.grantCode = null;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthenticationService.prototype.getAccessToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.grantCode == null || this.grantCode == undefined || this.grantCode == "")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getGrantCode()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        options = {
                            headers: {
                                client_id: client_id,
                                Authorization: 'Basic ' + authorization
                            }
                        };
                        body = {
                            code: this.grantCode,
                            grant_type: 'authorization_code'
                        };
                        return [4 /*yield*/, this.http.post(host + "/oauth/access-token", body, options)
                                .pipe(retry(3), map(function (response) {
                                return response.access_token;
                            }))
                                .toPromise()
                                .then(function (response) {
                                return _this.accessToken = response;
                            }).catch(function (err) {
                                return _this.accessToken = null;
                            })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthenticationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.HttpBackend)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());
export { AuthenticationService };
